<style>
.publish_files {
  background: #ffffff;
  padding: 20px;
}

.publish_files .subject {
  margin-top: 30px;
}

.publish_files .subject ul li {
  display: flex;
  justify-content: space-between;
  padding: 20px;
}

.publish_files .subject ul li.subject_header {
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  color: #fff;
  font-weight: 900;
  background: #232020;
}

.publish_files .subject ul li div {
  max-width: 250px;
  width: 100%;
  text-align: center;
}

.publish_files .subject ul li div.operation {
  display: flex;
  gap: 10px;
  justify-content: center;
}

.publish_files .subject ul li div.operation i {
  cursor: pointer;
}

.el-icon-edit-outline:before,
.el-icon-delete:before {
  font-size: 30px;
}

.new_primary {
  max-width: 500px;
  width: 100%;
  border: 1px solid;
  padding: 30px;
  border-radius: 10px;
  position: fixed;
  top: 35%;
  left: 35%;
  background: #ffffff;
}

.new_primary ul li {
  margin-bottom: 30px;
}

.el-button {
  width: 180px;
}

.cancel_submit {
  text-align: center;
}

.new_primary ul li span {
  color: #ff4d4f;
  font-size: 14px;
}
</style>
<template>
  <div class="publish_files">
    <el-button @click="new_primary" type="primary">新建用户</el-button>
    <div class="subject">
      <ul>
        <li class="subject_header">
          <div>ID</div>
          <div>用户名</div>
          <div>邮箱</div>
          <div>创建时间</div>
          <div>操作</div>
          <div>重置绑定</div>
        </li>
        <li
          class="subject_content"
          v-for="(item, index) in content"
          :key="index"
        >
          <div>{{ item.id }}</div>
          <div>{{ item.name }}</div>
          <div>{{ item.email }}</div>
          <div>{{ item.created_at }}</div>
          <div class="operation">
            <i @click="modification(index)" class="el-icon-edit-outline"></i>
            <i @click="files_delete(item.id)" class="el-icon-delete"></i>
          </div>
          <div>
            <el-button
              v-if="content[index].is_bind == 1"
              @click="reset(item.id)"
              type="primary"
              >重置</el-button
            >
            <el-button v-if="content[index].is_bind == 0" type="info"
              >未绑定</el-button
            >
          </div>
        </li>
      </ul>
    </div>
    <div class="new_primary" v-if="presence">
      <ul>
        <li class="email">
          <el-input
            placeholder="请输入邮箱"
            @blur="panduan_email"
            ref="myInput"
            v-model="email"
            clearable
          ></el-input>
          <span class="Username_error" v-if="files_email == 1">请输入邮箱</span>
          <span class="Username_error">{{ email_text }}</span>
        </li>
        <li class="password">
          <el-input
            placeholder="请输入密码"
            v-model="password"
            clearable
          ></el-input>
          <span class="Username_error" v-if="files_password == 1"
            >请输入密码</span
          >
        </li>
        <li class="name">
          <el-input
            placeholder="请输入用户名"
            v-model="name"
            clearable
          ></el-input>
          <span class="Username_error" v-if="files_name == 1"
            >请输入用户名</span
          >
        </li>
      </ul>
      <div class="cancel_submit">
        <el-button @click="files_cancel" type="primary">取消</el-button>
        <el-button
          v-if="files_modification"
          @click="files_submit"
          type="primary"
          >提交</el-button
        >
        <el-button
          v-if="!files_modification"
          @click="modification_submit"
          type="primary"
          >修改</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery'
import cookies from 'js-cookie'
export default {
  data () {
    return {
      content: '',//获取所有的用户信息
      email: '',//新建用户的邮箱
      files_email: '',
      email_text: '',
      password: '',//新用户的密码
      files_password: "",
      name: '',//新建用户的用户名
      name_text: '',
      files_name: '',
      presence: false,
      files_modification: true,
    }
  },
  watch: {
    'email' (oldval,) {
      if (oldval == "") {
        $('.email .el-input__inner').css("border", "1px solid #ff4d4f")
      } else {
        $('.email .el-input__inner').css("border", "1px solid #BBBABA")
      }
    },
    'password' (oldval,) {
      if (oldval == "") {
        this.files_password = 1,
          $('.password .el-input__inner').css("border", "1px solid #ff4d4f")
      } else {
        this.files_password = "",
          $('.password .el-input__inner').css("border", "1px solid #BBBABA")
      }
    },
    'name' (oldval,) {
      if (oldval == "") {
        this.files_name = 1,
          $('.name .el-input__inner').css("border", "1px solid #ff4d4f")
      } else {
        this.files_name = "",
          $('.name .el-input__inner').css("border", "1px solid #BBBABA")
      }
    },
  },
  mounted () {
    this.getDatas()
  },
  methods: {
    files_delete (e) {
      this.$confirm('此操作将删除该账号, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message({
          type: 'success',
          message: '删除成功!',
        })
        console.log(e)
        let delete_id = e
        let this_f = this
        $.ajax({
          type: "DELETE",
          url: "https://google-analytics-test.canglankeji.com/api/user/delete/" + delete_id,
          headers: {
            Authorization: "Bearer " + cookies.get("token"),
          },
          dataType: 'json',
          success: function (res) {
            console.log(res)
            this_f.content = ''
            this_f.getDatas()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    reset (e) {//重置绑定主机
        let this_f = this
      this.$confirm('此操作将重置绑定, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message({
          type: 'success',
          message: '重置成功!'
        })
        $.ajax({
          type: "put",
          url: "https://google-analytics-test.canglankeji.com/api/user/update/" + e,
          data: {
            reset_bind: 1,
          },
          headers: {
            Authorization: "Bearer " + cookies.get("token"),
          },
          dataType: 'json',
          success: function (res) {
            console.log(res)
              this_f.email = ''
              this_f.password = ''
              this_f.name = ''

              this_f.content = ''
              this_f.getDatas()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消重置'
        })
      })
    },
    files_submit () { //点击创建新用户
      if (this.email == "") {
        this.files_email = 1,
          $('.email .el-input__inner').css("border", "1px solid #ff4d4f")
      } else {
        this.files_email = 0,
          $('.email .el-input__inner').css("border", "1px solid #BBBABA")
      }
      if (this.password == "") {
        this.files_password = 1,
          $('.password .el-input__inner').css("border", "1px solid #ff4d4f")
      } else {
        this.files_password = "",
          $('.password .el-input__inner').css("border", "1px solid #BBBABA")
      }
      if (this.name == "") {
        this.files_name = 1,
          $('.name .el-input__inner').css("border", "1px solid #ff4d4f")
      } else {
        this.files_name = "",
          $('.name .el-input__inner').css("border", "1px solid #BBBABA")
      }
      if (this.password != "" & this.name != "" & this.email != "") {
        let this_f = this
        $.ajax({
          type: "post",
          url: "https://google-analytics-test.canglankeji.com/api/user/create",
          data: {
            email: this_f.email,
            password: this_f.password,
            name: this_f.name,
            user_department_id: 0,
            user_role_id: 0,
          },
          headers: {
            Authorization: "Bearer " + cookies.get("token"),
          },
          dataType: 'json',
          success: function (res) {
            console.log(res)
            if (res.code == -1) {
              this_f.name_text = res.message
              $('.name .el-input__inner').css("border", "1px solid #ff4d4f")
            } else if (res.code == 0) {
              this_f.name_text = ''
              $('.name .el-input__inner').css("border", "1px solid #BBBABA")
              this_f.presence = false
              this_f.email = ''
              this_f.password = ''
              this_f.name = ''

              this_f.content = ''
              this_f.getDatas()

            }
          }
        })
      }
    },
    panduan_email () {//判断邮箱是否存在
      let this_f = this
      $.ajax({
        type: "GET",
        url: "https://google-analytics-test.canglankeji.com/api/user/check_email_exist",
        data: {
          email: this.email,
        },
        headers: {
          Authorization: "Bearer " + cookies.get("token"),
        },
        dataType: 'json',
        success: function (res) {
          if (res.code == -1) {
            this_f.email_text = res.message
            $('.email .el-input__inner').css("border", "1px solid #ff4d4f")
          } else if (res.code == 0) {
            this_f.email_text = ''
            this_f.files_email = 0,
              $('.email .el-input__inner').css("border", "1px solid #BBBABA")
          }
        }
      })
    },
    modification_submit () {
      if (this.password != "" & this.name != "" & this.email != "") {
        let this_f = this
        $.ajax({
          type: "put",
          url: "https://google-analytics-test.canglankeji.com/api/user/update/2",
          data: {
            email: this_f.email,
            password: this_f.password,
            name: this_f.name,
            user_department_id: 0,
            user_role_id: 0,
          },
          headers: {
            Authorization: "Bearer " + cookies.get("token"),
          },
          dataType: 'json',
          success: function (res) {
            console.log(res)
            if (res.code == -1) {
              this_f.name_text = res.message
              $('.name .el-input__inner').css("border", "1px solid #ff4d4f")

            } else if (res.code == 0) {
              this_f.name_text = ''
              $('.name .el-input__inner').css("border", "1px solid #BBBABA")
              this_f.presence = false
              this_f.files_modification = true
              this_f.email = ''
              this_f.password = ''
              this_f.name = ''

              this_f.content = ''
              this_f.getDatas()

            }
          }
        })
      }
    },
    modification (e) { //修改用户信息
      console.log(e)
      this.files_modification = false
      this.presence = true
      this.email = this.content[e].email
      this.name = this.content[e].name
    },
    files_cancel () {//点击取消新建
      this.presence = false
    },
    new_primary () { //新建用户
      this.email = ''
      this.name = ''
      this.presence = true
    },
    getDatas () {//获取所有用户
      this.user_name = cookies.get("user_name")
      let this_f = this
      $.ajax({
        type: "get",
        url: "https://google-analytics-test.canglankeji.com/api/user",
        data: {
          page: 1,
          limit: 50,
        },
        headers: {
          Authorization: "Bearer " + cookies.get("token"),
        },
        dataType: 'json',
        success: function (res) {
          console.log(res.result.items)
          this_f.content = res.result.items
        }
      })
    },

  },
}
</script>



// WEBPACK FOOTER //
// src/views/Publish_Files.vue